import { Collapse } from 'antd';
import { MemberTripConfig } from 'elem/compCommon/ProductConstructor/BriefGuide/Info/MemberTrip/const';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Q() {
    const { useLang, useRouter, useEffect, useState, gtm, Link, getSystemTime } = useGlobal();
    const { locale, pathname, query } = useRouter();
    const { t } = useLang('smart_home_panel_2.launch.detail');
    const { timer, includePaths, includeSites } = MemberTripConfig;

    const lists: any[] =
        locale === 'mx'
            ? [
                  {
                      title: t('secQ_terms_title4'),
                      desc: t('secQ_terms_content4'),
                  },
                  {
                      title: t('secQ_terms_title6'),
                      desc: t('secQ_terms_content6'),
                  },
                  locale !== 'us' && {
                      title: t('secQ_terms_titleFee'),
                      desc: t('secQ_terms_descFee'),
                  },
                  {
                      title: t('secQ_terms_title5'),
                      desc: t('secQ_terms_content5'),
                  },
              ]
            : locale === 'ca'
            ? [
                  //   {
                  //       title: t('secQ_terms_title1'),
                  //       desc: t('secQ_terms_content1'),
                  //   },
                  {
                      title: t('secQ_terms_title2'),
                      desc: t('secQ_terms_content2'),
                  },
                  {
                      title: t('secQ_terms_title3'),
                      desc: t('secQ_terms_content3'),
                  },
              ]
            : [
                  //   {
                  //       title: t('secQ_terms_title1'),
                  //       desc: t('secQ_terms_content1'),
                  //   },
                  //   {
                  //       title: t('secQ_terms_title2'),
                  //       desc: t('secQ_terms_content2'),
                  //   },
                  {
                      title: t('secQ_terms_title3'),
                      desc: t('secQ_terms_content3'),
                  },
                  {
                      title: t('secQ_terms_title4'),
                      desc: t('secQ_terms_content4'),
                  },
                  {
                      title: t('secQ_terms_title6'),
                      desc: t('secQ_terms_content6'),
                  },
                  locale !== 'us' && {
                      title: t('secQ_terms_titleFee'),
                      desc: t('secQ_terms_descFee'),
                  },
                  {
                      title: t('secQ_terms_title5'),
                      desc: t('secQ_terms_content5'),
                  },
              ].filter(Boolean);

    const [listsAll, setListsAll] = useState(lists);

    useEffect(() => {
        let serverTime = getSystemTime();
        if (!serverTime || serverTime < 1000000) {
            serverTime = new Date().getTime();
        }
        // 测试用
        if (query?.timerStart && query?.timerEnd) {
            timer.start = `${query?.timerStart}`;
            timer.end = `${query?.timerEnd}`;
        }
        const flag =
            includePaths?.includes(pathname) &&
            includeSites?.includes(locale) &&
            serverTime >= new Date(timer?.start)?.getTime() &&
            serverTime < new Date(timer?.end)?.getTime();
        if (flag) {
            setListsAll([
                ...lists,
                {
                    title: t('secQ_terms_titleMember'),
                    desc: t.rich('secQ_terms_contentMember', {
                        a: (text: string) => (
                            <a className="desc-link" href={`https://www.ecoflow.com/${locale}`} target="_self" rel="noreferrer">
                                {text}
                            </a>
                        ),
                    }),
                },
            ]);
        }
    }, [query]);

    return (
        <section className={`shp2-detail-Q shp2-detail-section ${css['shp2-detail-Q']}`}>
            {/* <p className="text">{t('secQ_text')}</p> */}
            <Collapse
                ghost={true}
                className="collapse-lists"
                // defaultActiveKey={0}
                // onChange={setActive}
                // accordion={true}
                expandIcon={({ isActive }: any) => {
                    return (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path d="M17.5 15L12.5 10L7.5 15" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    );
                }}
                expandIconPosition="right"
            >
                {listsAll?.map((list: any, k: number) => (
                    <Collapse.Panel className="list-title" key={k} header={list.title}>
                        <p className="list-desc">{list.desc}</p>
                    </Collapse.Panel>
                ))}
            </Collapse>
        </section>
    );
}
